module.exports = __webpack_public_path__ + "assets/img/7145-gr.svg";